/**
 * The customer guide behind each coach help dialog. Each stays null until its doc is public; the dialog's
 * "Read the full guide" link appears once its URL is set.
 */
export const GUIDE_LINKS: Record<"how" | "ask" | "backgrounds", string | null> = {
  how: null,
  ask: null,
  backgrounds: null,
};
